module.exports = __webpack_public_path__ + "img/color-2x.90064002.svg";